// Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';



import TextBox from "./TextBox";
import Button from "./Button";
import Logo from "./Logo";
//import Links from "./Links";

/**
 * Login component renders the user login form and handles authentication.
 *
 * It manages email and password input states, submits credentials to a backend,
 * handles success/failure messages, and redirects upon successful login.
 *
 * @returns {JSX.Element} The login form UI with input fields, buttons, messages, and links.
 */

const Login = () => {
  // State for the email input field
  const [email, setEmail] = useState('');
  // State for the password input field
  const [password, setPassword] = useState('');
  // State for showing status messages (success or error)
  const [message, setMessage] = useState('');
  // React Router hook to programmatically navigate after login
  const navigate = useNavigate();




   /**
   * Handles the form submission event for login.
   *
   * Sends a POST request with email and password to the backend API.
   * If login is successful, stores the token in sessionStorage, shows success message,
   * and navigates to the home page.
   * Otherwise, displays an error message from the server.
   *
   * @param {React.FormEvent<HTMLFormElement>} e - The form submission event.
   */
  const handleLogin = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch("https://security-backend-1nbc.onrender.com/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();

    if (res.ok) {
      // Store auth token for session persistence
      sessionStorage.setItem("token", data.token);
      console.log("Saved token:", sessionStorage.getItem("token"));
      
      setMessage("✅ Login successful!");
      navigate("/panel");
      
    } else {
      setMessage(`❌ ${data.error || "Login failed"}`);
    }
  } catch (err) {
    console.error("Login error:", err);
    setMessage("❌ Network error, please try again.");
  }
};

  return (

    <div className="login-page">
    <div className="login-container">
      {/* Company Logo */}
      <Logo />
      {/* Login form */}
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Login</h2>
        {/* Email input field */}
        <TextBox
          id="email"
          label="Email"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
        {/* Password input field */}
        <TextBox
          id="password"
          label="Password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />
        {/* Submit button */}
        <Button type="submit">Login</Button>
        {/* Status message (success or error) */}
        <p className="message">{message}</p>
      </form>
      {/* Links to password reset and sign up */}
      
    </div>
</div>

  );
};

export default Login;